export default "__VITE_ASSET__LkeD5Jyb__"